import cx from 'classnames'
import { useTranslation } from 'react-i18next'

import AppStoreButton from 'components/Button/AppStoreButton'
import PlayStoreButton from 'components/Button/PlayStoreButton'

import './style.scss'

const AppDownloadAds = ({ className = '' }: { className?: string }) => {
  const { t, i18n } = useTranslation()

  return (
    <div className={cx('AppDownloadAds', className)}>
      <div className="AppDownloadAds__banner">
        <div className="AppDownloadAds__banner__logo" />

        <img
          className="AppDownloadAds__banner__img"
          src={`/images/AppDownloadAds__banner__img--${
            i18n.language == 'ja' ? 'ja' : 'en'
          }.svg`}
          alt={t('footer.detail')}
        />
      </div>

      <div className="AppDownloadAds__download">
        <AppStoreButton />
        <PlayStoreButton />
      </div>
    </div>
  )
}

export default AppDownloadAds
